import React, { Component } from 'react';
import { Search, handleOnSearch, handleOnSearchLegacy } from '../search';
import { Icon } from '../asset/asset.type';
import { translatableText } from '../../utils/translatable-text';
import './global-hero.less';

interface Props {
    wrapperClassName?: string;
    title: string;
    primaryImage: Icon;
    secondaryImage: Icon;
    isNewSearchEnabled: boolean;
}

export default class GlobalHero extends Component<Props> {
    render() {
        const {
            wrapperClassName,
            title,
            primaryImage,
            secondaryImage,
            isNewSearchEnabled
        } = this.props;

        return (
            <section
                className={['global-hero', wrapperClassName].join(' ')}
                data-testid="global_hero"
            >
                <div className="global-hero__inner">
                    <div className="global-hero__top">
                        <h1
                            data-testid="hero_headline"
                            className="global-hero__headline"
                        >
                            {title}
                        </h1>
                        <p className="global-hero__headline--secondary margin-top-medium">
                            {translatableText.globalHeroHeadline.text}
                        </p>
                        <Search
                            onSearch={
                                isNewSearchEnabled
                                    ? handleOnSearch
                                    : handleOnSearchLegacy
                            }
                            placeholder="Search documentation"
                            className="margin-top-medium"
                            analyticsMetadata={{
                                parentComponent: 'home'
                            }}
                        />
                    </div>
                    <div className="global-hero__bottom">
                        <img
                            className="global-hero__img global-hero__img--book-people"
                            src={primaryImage.url}
                            alt="Global Hero Book People"
                        />
                        <img
                            className="global-hero__img global-hero__img--small-people"
                            src={secondaryImage.url}
                            alt="Global Hero Small People"
                        />
                    </div>
                </div>
            </section>
        );
    }
}
